import { render, staticRenderFns } from "./Monitorization.vue?vue&type=template&id=28f7de7b&"
import script from "./Monitorization.vue?vue&type=script&lang=js&"
export * from "./Monitorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports